<template>
  <v-row>
    <v-col cols="12">
      <v-simple-table class="elevation-1">
        <thead>
          <tr>
            <th class="text-left">Listado de zonas</th>
            <th class="text-left">Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(zone) in sellerZones" :key="zone.ID_SellerZone">
            <td>{{ zone.Name }}</td>
            <td>
              <button @click="removeSellerZone(zone)">
                <v-icon color="error">
                  mdi-delete
                </v-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-col>
    <block v-if="loading" />
  </v-row>
</template>

<script>
export default {
  name: "ManageStoreSellerZoneTable",
  props: {
    sellerZones: Array
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    removeSellerZone(zoneToDelete) {
      this.loading = true
      this.$API.sellerZone.deleteSellerZoneBy(zoneToDelete.ID_SellerZone)
        .then(sellerZones => {
          if (sellerZones.success) {
            this.$emit('onDelete')
          }
        })
        .finally(() => this.loading = false)
    }
  }

}
</script>